/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { log } from '../fn/logger-controller/log';
import { Log$Params } from '../fn/logger-controller/log';

@Injectable({ providedIn: 'root' })
export class LoggerControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `log()` */
  static readonly LogPath = '/logger';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `log()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  log$Response(params: Log$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return log(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `log$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  log(params: Log$Params, context?: HttpContext): Observable<void> {
    return this.log$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
